import { useState, useEffect } from 'react';
import { Link, useLocation } from 'react-router-dom';

export default function Navbar() {
  const [scrolled, setScrolled] = useState(false);
  const [mobileOpen, setMobileOpen] = useState(false);
  const location = useLocation();

  useEffect(() => {
    const handleScroll = () => setScrolled(window.scrollY > 60);
    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  useEffect(() => {
    setMobileOpen(false);
  }, [location]);

  const isActive = (path: string) => location.pathname === path;

  return (
    <nav
      className={`fixed top-0 left-0 w-full z-50 transition-all duration-300 ${
        scrolled
          ? 'bg-background-50/95 backdrop-blur-md'
          : 'bg-transparent'
      }`}
    >
      <div className="w-full px-4 md:px-6">
        <div className="flex items-center justify-between h-16">
          <Link to="/" className="flex items-center gap-2 whitespace-nowrap">
            <div className="w-9 h-9 flex items-center justify-center bg-primary-500 rounded-lg">
              <i className="ri-movie-2-fill text-background-50 text-lg"></i>
            </div>
            <span className={`font-heading text-xl font-bold transition-colors duration-300 ${
              scrolled ? 'text-foreground-900' : 'text-background-50'
            }`}>
              6080电影网
            </span>
          </Link>

          <div className="hidden md:flex items-center gap-8">
            <Link
              to="/"
              className={`whitespace-nowrap text-sm font-medium transition-colors duration-300 ${
                isActive('/')
                  ? scrolled ? 'text-primary-600' : 'text-primary-300'
                  : scrolled ? 'text-foreground-700 hover:text-primary-600' : 'text-background-50/90 hover:text-background-50'
              }`}
            >
              首页
            </Link>
            <Link
              to="/category/all"
              className={`whitespace-nowrap text-sm font-medium transition-colors duration-300 ${
                location.pathname.startsWith('/category')
                  ? scrolled ? 'text-primary-600' : 'text-primary-300'
                  : scrolled ? 'text-foreground-700 hover:text-primary-600' : 'text-background-50/90 hover:text-background-50'
              }`}
            >
              分类
            </Link>
            <Link
              to="/about"
              className={`whitespace-nowrap text-sm font-medium transition-colors duration-300 ${
                isActive('/about')
                  ? scrolled ? 'text-primary-600' : 'text-primary-300'
                  : scrolled ? 'text-foreground-700 hover:text-primary-600' : 'text-background-50/90 hover:text-background-50'
              }`}
            >
              关于我们
            </Link>
          </div>

          <button
            onClick={() => setMobileOpen(!mobileOpen)}
            className={`md:hidden w-10 h-10 flex items-center justify-center rounded-lg transition-colors ${
              scrolled ? 'text-foreground-700 hover:bg-background-200' : 'text-background-50 hover:bg-background-50/20'
            }`}
            aria-label="菜单"
          >
            <i className={`text-xl ${mobileOpen ? 'ri-close-line' : 'ri-menu-line'}`}></i>
          </button>
        </div>

        {mobileOpen && (
          <div className="md:hidden bg-background-50 border-t border-background-200 pb-4 pt-3 px-2">
            <Link
              to="/"
              className={`block px-4 py-3 rounded-lg text-sm font-medium transition-colors ${
                isActive('/') ? 'bg-primary-100 text-primary-700' : 'text-foreground-700 hover:bg-background-100'
              }`}
            >
              <i className="ri-home-4-line mr-2"></i>首页
            </Link>
            <Link
              to="/category/all"
              className={`block px-4 py-3 rounded-lg text-sm font-medium transition-colors ${
                location.pathname.startsWith('/category') ? 'bg-primary-100 text-primary-700' : 'text-foreground-700 hover:bg-background-100'
              }`}
            >
              <i className="ri-grid-line mr-2"></i>分类
            </Link>
            <Link
              to="/about"
              className={`block px-4 py-3 rounded-lg text-sm font-medium transition-colors ${
                isActive('/about') ? 'bg-primary-100 text-primary-700' : 'text-foreground-700 hover:bg-background-100'
              }`}
            >
              <i className="ri-information-line mr-2"></i>关于我们
            </Link>
          </div>
        )}
      </div>
    </nav>
  );
}